import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { ListParams } from 'models';

export interface alarmState {
  loading: boolean | null;
}

const initialState: alarmState = {
  loading: null,
};

const alarmSlice = createSlice({
  name: 'alarm',
  initialState,
  reducers: {
    fetchPropertiesAlarm(state, action: PayloadAction<ListParams>) {
      state.loading = false;
    },
    fetchPropertiesAlarmSuccess(state) {
      state.loading = true;
    },
    fetchDataReset(state) {
      state.loading = null;
    },
  },
});
//Actions
export const alarmActions = alarmSlice.actions;

//Select
export const selectAlarmLoading = (state: RootState) => state.alarmReducer.loading;

//Reducer
const alarmReducer = alarmSlice.reducer;
export default alarmReducer;
